import { render, staticRenderFns } from "./menuAppTree.vue?vue&type=template&id=198b100d&scoped=true&"
import script from "./menuAppTree.vue?vue&type=script&lang=js&"
export * from "./menuAppTree.vue?vue&type=script&lang=js&"
import style0 from "./menuAppTree.vue?vue&type=style&index=0&id=198b100d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b100d",
  null
  
)

export default component.exports